import React from "react";
import { StandardStyled } from "./styled";
import cx from "classnames";
import { useTable, useSortBy, useRowSelect } from "react-table";
import { MdDelete } from "react-icons/md";
import { Displays } from "components";

const PER_PAGE_OPTIONS = [10, 25, 50, 100];

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input type="checkbox" ref={resolvedRef} {...rest} />
      </>
    );
  },
);

export const Standard = ({
  columns,
  data,
  pagination,
  showPagination,
  handlePageClick,
  onChangePerPage,
  onDelete,
  onRowClick,
  isSelect,
}) => {
  const customClass = cx({});
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable(
    {
      columns,
      data,
    },
    useSortBy,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        // Let's make a column for selection
        {
          id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          // Header: ({ getToggleAllPageRowsSelectedProps }) => (
          //   <div>
          //     <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps()} />
          //   </div>
          // ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) =>
            !isSelect ? (
              <></>
            ) : (
              <div>
                <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
              </div>
            ),
        },
        ...columns,
      ]);
    },
  );

  // pagination.per_page มาจาก limit ที่ API ตอบกลับ จึงตรงกับจำนวนแถวที่แสดงจริง
  // ค่าที่ไม่อยู่ในตัวเลือก (เช่น 20) ให้เพิ่มเข้าไป ไม่งั้น select จะโชว์ค่าผิด
  const perPageValue = Number(pagination?.per_page) || PER_PAGE_OPTIONS[0];
  const perPageOptions = PER_PAGE_OPTIONS.includes(perPageValue)
    ? PER_PAGE_OPTIONS
    : [...PER_PAGE_OPTIONS, perPageValue].sort((a, b) => a - b);
  const rangeFrom = pagination?.total
    ? (pagination.current_page - 1) * perPageValue + 1
    : 0;
  const rangeTo = pagination?.total
    ? Math.min(pagination.current_page * perPageValue, pagination.total)
    : 0;

  const _handleDelete = () => {
    onDelete && onDelete(selectedFlatRows.map((d) => d.original));
  };

  return (
    <StandardStyled>
      <div className={customClass}>
        {selectedFlatRows && selectedFlatRows.length > 0 && (
          <div className="table_action_row">
            <div className="ta_delet_btn" onClick={_handleDelete}>
              <MdDelete fontSize={18} color="gray" />
            </div>
          </div>
        )}
        <div className="table_scroll_x">
          <table {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      onClick={() => column.toggleSortBy(!column.isSortedDesc)}
                    >
                      {/* <div className="header_group"> */}
                      {column.render("Header")}
                      {/* Add a sort direction indicator */}
                      <span className="sort">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                      {/* </div> */}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    onClick={() => onRowClick && onRowClick(row.original)}
                  >
                    {row.cells.map((cell) => {
                      return cell.column.id === "no" ? (
                        <td {...cell.getCellProps()}>{i + 1}</td>
                      ) : (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {showPagination && pagination && data && data.length > 0 && (
          <div className="pagi_layout">
            <div className="pagi_info">
              {onChangePerPage && (
                <div className="per_page">
                  <span>จำนวนแถวต่อหน้า</span>
                  <select
                    value={perPageValue}
                    onChange={(e) => onChangePerPage(Number(e.target.value))}
                  >
                    {perPageOptions.map((e) => (
                      <option key={e} value={e}>
                        {e}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {pagination.total !== undefined && (
                <div className="range">
                  {`${rangeFrom.toLocaleString()}-${rangeTo.toLocaleString()} จาก ${Number(pagination.total).toLocaleString()}`}
                </div>
              )}
            </div>
            <Displays.PaginationCustom
              theme_standard_pagination
              totalPages={pagination?.last_page}
              currentPageData={pagination?.current_page - 1}
              _handlePageClick={handlePageClick}
            />
          </div>
        )}
      </div>
    </StandardStyled>
  );
};

export default Standard;
